import React from "react";

import TableContainer from "../TableContainer";

interface ItemTableProps {
  colorName?: string;
  columns?: any;
  data?: any;
}
const ItemsTable: React.FC<ItemTableProps> = ({ colorName, columns, data }) => {
  // Dynamic data - you can pass this as props or fetch from API

  return (
    <TableContainer
      columns={columns}
      data={data ?? []}
      showPagination={false}
      customPageSize={data.length}
      divClass="table-responsive mb-2 bg-white mt-2"
      tableClass="align-middle table-nowrap"
      thClass="fw-medium fs-14 font-primary bg-white member-table"
      theadClass="table-light"
      colorName={colorName}
    />
  );
};

export default React.memo(ItemsTable);
